import { HelpOutlineOutlined } from '@mui/icons-material'

import { NavbarItem } from '@collaborate-health/uikit'

const HelpTab: React.FC = () => {
  return (
    <NavbarItem
      name='Help'
      icon={<HelpOutlineOutlined />}
      onClick={() => window.open('https://talonsupport.freshdesk.com/support/home', '_blank')}
    />
  )
}

export default HelpTab

